<template>
	<section class="section section--video">
		<app-video />
	</section>
</template>

<script>
	import Video from '@/pages/video/video.vue'
	
	export default {
		components: {
			appVideo: Video
		}
	}
</script>
